import { render } from "./RoundStatisticsContent.vue?vue&type=template&id=bf6458c2&scoped=true"
import script from "./RoundStatisticsContent.vue?vue&type=script&lang=js"
export * from "./RoundStatisticsContent.vue?vue&type=script&lang=js"

import "./RoundStatisticsContent.vue?vue&type=style&index=0&id=bf6458c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6458c2"]])

export default __exports__